/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useProduct } from '@modules/product';
import { useSize } from '@modules/size/composables';

export const useGiftConsolidated = () => {
  const { productId } = useProduct();
  const { selectedSizeId, sizes } = useSize(productId);

  const selectedGift = computed({
    get() {
      return selectedSizeId.value;
    },
    set(value) {
      selectedSizeId.value = value;
    },
  });

  const giftOptions = computed(
    () => sizes
      .value
      .map((size) => ({ id: size.id.toString(), text: size.displayName })),
  );

  return {
    selectedGift,
    giftOptions,
  };
};
